import React, {useMemo} from "react";

import styles from './Input.module.css'
import {cn} from "../../../utils/cn.ts";
import {useVisibilityToggle} from "./hook/useVisibilityToggle.tsx";

interface Props {
    label?: string | {name: string, value: string} // {name: 'Индекс', value: postcode}
    placeholder?: string,
    className?: string,
    value?: string | number,
    list?: { id: number, name: string }[],
    changeStateValue?: (value: any | null) => void,
    selectListData?: (value: number, label: string) => void,
    icon?: React.ReactNode,
    disabled?: boolean,
    classNameInput?: string
    hasBorder?: boolean
    onInput?: (value: string) => void
    maxLength?: number
    wrapperStyle?: any
    type?: 'number' | 'password'
    style?: any
}

    export const Input: React.FC<Props & React.HTMLAttributes<HTMLInputElement>> = ({
        maxLength,
                                                                                        wrapperStyle,
                                                                                        placeholder,
                                                                                        className,
                                                                                        classNameInput,
                                                                                        onInput,
                                                                                        label,
                                                                                        icon,
                                                                                        hasBorder = false,
                                                                                        type,
                                                                                        value,
                                                                                        changeStateValue,
                                                                                        disabled = false,
                                                                                        list,
                                                                                        selectListData,
                                                                                        style
    }) => {
        const {isShown, visibilityToggle} = useVisibilityToggle()

        const inputType = useMemo(() => {
            if (type === 'password') {
                return isShown ? 'text' : 'password'
            }

            if (type) return type

            return 'text';

        }, [isShown, type])
    const labelName = typeof label === 'string' ? label : label?.name;
    const labelValue = typeof label === 'string' ? label : label?.value;

    const onChange = (value: string | number) => {if(changeStateValue) changeStateValue(value);}

    const inputAttrs = {
        ...({name: labelValue}),
        ...(maxLength && {maxLength}),
    }

    return (<div className={styles.wrapper} style={wrapperStyle ? wrapperStyle : {}}>
        {label && <label className={styles.label} htmlFor={labelValue}>{labelName}</label>}
        <div className={cn(styles.container, hasBorder && styles.border, disabled && styles.disabled, className)}>
            <input
                {...inputAttrs}
                placeholder={placeholder}
                onChange={event => onChange(event.target.value)}
                value={value}
                disabled={disabled}
                type={inputType}
                style={style}
                className={cn(styles.input, classNameInput)}
                onInput={(e) => {
                    if (!onInput) return;

                    const value: string = (e.target as HTMLInputElement).value;
                    onInput(value)
                }}
            />
            {type === 'password' && visibilityToggle}
            {icon && (icon)}

        {
            list && list.length
                ? <div className={styles.inputListBlock}>
                        <ul className={styles.inputList}>
                            {
                                list.map((data: { id: number, name: string }) =>
                                    (<li key={data.id} className={cn(styles.inputListElement)} onClick={() => {
                                        if (selectListData) selectListData(data.id, data.name);
                                    }}>{data.name}</li>))
                            }
                        </ul>
                    </div>
                    : null
            }
        </div>
    </div>)
    }